import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';
import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
  selectContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.accentGrayUltralight};
    }
  `,
};

const Country = props => {
  const { form, info, step, currentInfo, key, onChange } = props;
  const {
    label,
    persist,
    meta,
    field,
    formOverrides = {},
    options = [],
    optionId,
    optionDesc,
  } = info;

  const dispatch = useDispatch();
  const { register } = useSelector(state => state);

  const { isOtherCountryVisible, CountryCode } = register;

  const countryChange = e => {
    if (e === 'Other') {
      dispatch(handleFormChange({ name: 'isOtherCountryVisible', value: true }));
    } else {
      dispatch(handleFormChange({ name: 'isOtherCountryVisible', value: false }));
    }
  };

  useEffect(() => {
    if (register.CountryCode === 'Other') {
      dispatch(handleFormChange({ name: 'isOtherCountryVisible', value: true }));
      dispatch(handleFormChange({ name: 'OfficeStateOther', value: 'Other' }));
      dispatch(handleFormChange({ name: 'StateCode', value: 'Other' }));
    } else {
      dispatch(handleFormChange({ name: 'isOtherCountryVisible', value: false }));
      dispatch(handleFormChange({ name: 'OfficeStateOther', value: '' }));
      dispatch(handleFormChange({ name: 'StateCode', value: '' }));
    }
  }, [CountryCode]);

  return (
    <>
      <div key={optionId} css={styles.selectContainer}>
        <Form.Item
          label="Country"
          extra="Note: If your country does not appear in the list, select Other and enter the country name in the box that appears below."
        >
          {form.getFieldDecorator('CountryCode', {
            initialValue: register['CountryCode'],
            ...formOverrides,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              allowClear
              onChange={e => {
                countryChange(e);
                onChange(field, e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
            >
              {options.map(option => (
                <Option key={`${field}-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherCountryVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="Enter Country">
            {form.getFieldDecorator('Country', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter Country.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('Country', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ register }) => {
  return {
    register,
  };
};

Country.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default Country;
